import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import Home from '@/components/Home'
import Join from '@/components/Join'
import Templates from '@/components/Templates'
import Transaction from '@/components/Transaction'
import Maintenance from '@/components/Maintenance'
import SupplierDocuments from '@/pages/SupplierChecklist/SupplierDocuments'
import LenderDocuments from '@/components/LenderDocuments'
import SupplierChecklist from '@/pages/SupplierChecklist/SupplierChecklist'
import DocumentChecklist from '@/pages/SupplierChecklist/DocumentChecklist'
import ClientChecklist from '@/pages/SupplierChecklist/ClientChecklist'
import ChecklistTemplates from '@/pages/SupplierChecklist/ChecklistTemplates'
import Preferences from '@/components/Preferences'
import Settings from '@/components/Settings'
import Dashboards from '@/components/Dashboards'
import LayoutPage from '@/components/LayoutPage'
import GridScreen from '@/screens/GridScreen'
import BillingOld from '@/screens/BillingOld'
import Workflow from '@/flow/Workflow'
import Billing from '@/pages/Billing/Billing'
import OneInvoice from '@/pages/Billing/OneInvoice'
import SystemEditor from '@/system/SystemEditor'
import LayoutPage2 from '@/components/LayoutPage2'
import DownloadPage from '@/components/DownloadPage'
import LayoutPage3 from '@/components/LayoutPage3'
import LivingExpenses from '@/pages/LivingExpenses/LivingExpenses'
import ItemList from '@/components/ItemList'
import Components from '@/components/Components'
import ChartRotator from '@/pages/Charts/ChartRotator'
import ChartSelector from '@/pages/Charts/ChartSelector'
import Print from '@/components/Print'
import Console from '@/components/Console'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import MailLog from '@/components/MailLog'
import firebase from 'firebase/app'
import 'firebase/auth'

import Sample from '@/forms/Sample'

//Document Collective...

import DcMaintenance from '@/dc/Maintenance'
import DcPreferences from '@/dc/Preferences'
import Checklist from '@/dc/Checklist'
import Policies from '@/dc/Policies'

Vue.use(Router)

//export default new Router({
const router = new Router({
    // scrollBehavior (to, from, savedPosition) {
    //     return { x: 0, y: 0 }
    // },  
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/join',
      name: 'Join',
      component: Join
    },
    {
      path: '/layout',
      name: 'LayoutPage',
      component: LayoutPage,
      meta: {
        auth: true
      }  
    },
    {
      path: '/layout2',
      name: 'LayoutPage2',
      component: LayoutPage2,
      meta: {
        auth: true
      }  
    },
    {
      path: '/download',
      name: 'DownloadPage',
      component: DownloadPage,
      meta: {
        auth: true
      }  
    },
    {
      path: '/layout3',
      name: 'LayoutPage3',
      component: LayoutPage3,
      meta: {
        auth: true
      }  
    },
    {
      path: '/print',
      name: 'Print',
      component: Print,
      meta: {
        auth: true
      }  
    },
    {
      path: '/supplier-documents',
      name: 'SupplierDocuments',
      component: SupplierDocuments
    },
    {
      path: '/lender-documents',
      name: 'LenderDocuments',
      component: LenderDocuments
    },
    {
      path: '/:tenant/supplier-checklist/:transaction?',
      name: 'SupplierChecklist',
      component: SupplierChecklist,
      props: (route) => ({
        tenantKey: route.params.tenant,
        transactionKey: route.params.transaction
      }),
    },
    {
      path: '/:tenant/document-checklist/:checklist?',
      name: 'DocumentChecklist',
      component: DocumentChecklist,
      props: (route) => ({
        tenantKey: route.params.tenant,
        checklistKey: route.params.checklist,
        transactionKey: route.query.t,
      }),
    },
    {
      path: '/:tenant/checklist-templates/:checklist?',
      name: 'ChecklistTemplates',
      component: ChecklistTemplates,
      props: (route) => ({
        tenantKey: route.params.tenant,
        checklistKey: route.params.checklist,
      }),
    },  
    {
      path: '/client-checklist/:checklist?',
      name: 'ClientChecklist',
      component: ClientChecklist,
      props: (route) => ({
        checklistKey: route.params.checklist,
      }),
    },
    {
      path: '/console',
      name: 'Console',
      component: Console,
    },
    {
      path: '/preferences',
      name: 'Preferences',
      component: Preferences,
      props: (route) => ({
        tenantKey: route.query.t,
        uid: route.query.u,
      }),
      meta: {
        auth: true
      }    
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        auth: true
      }    
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: {
        auth: false
      }    
    },
    {
      path: '/:tenant/transaction/:transaction',
      name: 'Transaction',
      component: Transaction,
      props: (route) => ({
        tenantKey: route.params.tenant,
        transactionKeyProp: route.params.transaction
      }),      
      meta: {
        auth: true
      }    
    },
    {
      path: '/maintenance/',
      name: 'Maintenance',
      component: Maintenance,
      props: (route) => ({
        item: route.query.item,
        action: route.query.action,
        transactionKey: route.query.transaction,
      }),      
      meta: {
        auth: true
      }    
    },

    {
      path: '/templates/:template?',
      name: 'Templates',
      component: Templates,
      props: (route) => ({
          selectedKey: route.params.template
      }),
      meta: {
        auth: true
      }    
    },   
    {
      path: '/dashboards/:dashboard?',
      name: 'Dashboards',
      component: Dashboards,
      props: (route) => ({
          dashKey: route.params.dashboard
      }),
      meta: {
        auth: true
      }    
    },   

    {
      path: '/living',
      name: 'LivingExpenses',
      component: LivingExpenses
    },        
    {
      path: '/item-list/:page',
      name: 'ItemList',
      component: ItemList,
    },  
    {
      path: '/:tenant/charts/rotate',
      name: 'ChartRotator',
      component: ChartRotator,
      props: (route) => ({
        tenantKey: route.params.tenant,
      }),          
      meta: {
        auth: true
      }      
    },  
    {
      path: '/:tenant/charts/select',
      name: 'ChartSelector',
      component: ChartSelector,
      props: (route) => ({
        tenantKey: route.params.tenant,
      }),          
      meta: {
        auth: true
      }      
    },  
    {
      path: '/grid',
      name: 'GridScreen',
      component: GridScreen,
      props: (route) => ({
        pageNumber: route.query.p,
      }),        
      meta: {
        auth: true
      }      
    },  
    {
      path: '/system',
      name: 'SystemEditor',
      component: SystemEditor,
      props: (route) => ({
        collectionId: route.query.c,
        teamId: route.query.t,
      }),        
      meta: {
        auth: true
      }      
    },  
    {
      path: '/mail-log',
      name: 'MailLog',
      component: MailLog,
      props: (route) => ({
        logId: route.query.l,
        email: route.query.e,
      }),        
      meta: {
        auth: true
      }      
    },  
    {
      path: '/billingold',
      name: 'BillingOld',
      component: BillingOld,      
      meta: {
        auth: true
      },
      props: (route) => ({
        admin: route.query.admin,
      }),        
    },  
    {
      path: '/billing',
      name: 'Billing',
      component: Billing,      
      meta: {
        auth: true
      },
      props: (route) => ({
        admin: route.query.admin,
      }),        
    },  
    {
      path: '/workflow/:flow',
      name: 'Workflow',
      component: Workflow,      
      meta: {
        auth: true
      },     
      props: (route) => ({
        flowId: route.params.flow,
      }),    
    },  
    {
      path: '/invoice/:month/:invoice',
      name: 'OneInvoice',
      component: OneInvoice,      
      meta: {
        auth: false
      },
      props: (route) => ({
        invoiceKey: route.params.invoice,
        month: route.params.month
      }),        
    },  
    {
      path: '/components',
      name: 'Components',
      component: Components,
      meta: {
        auth: true
      }      
    },  
    {
      path: '/dc/maintenance',
      name: 'DcMaintenance',
      component: DcMaintenance,
      meta: {
        auth: true
      },
      props: (route) => ({
        i: route.query.i,
      }),                
    },  
    {
      path: '/dc/preferences',
      name: 'DcPreferences',
      component: DcPreferences,
      meta: {
        auth: true
      },               
    },  
    {
      path: '/dc/policies',
      name: 'Policies',
      component: Policies,               
    },  
    {
      path: '/dc/checklist',
      name: 'Checklist',
      component: Checklist,               
    },  
    {
      path: '/forms/Sample',
      name: 'Sample',
      component: Sample,
      meta: {
        auth: true
      },                
    },  
    {
      path: '/',
      redirect: '/home',
    },         
  ]

})

//Note router meta auth field not active. See app.vue loginDialogVisible computed property for public pages.

router.beforeEach(function (to, from, next) {

    let requiresAuth = to.matched.some(record => record.meta.auth)
    
    // If route requires auth --> load auth state first from firebase
    if (requiresAuth) {
        firebase.auth().onAuthStateChanged(user => {
            //let uid = firebase.auth().currentUser.uid
            console.log('Router waited for auth')
            if(!user) {   
              debugger
              return
            }
            else 
                next()
        })

    } 
    else {
        console.log('Router is skipping auth')
        next()
    }



    // window.scrollTo(0, 0)
    // next()
})   

export default router





// WEBPACK FOOTER //
// ./src/router/index.js